import { useEffect, useState } from "react";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "../components/ui/accordion";
import { api } from "../lib/api";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    api.get("/content/faqs").then(({ data }) => setFaqs(data)).catch(() => {});
  }, []);

  return (
    <div data-testid="faq-page">
      <section className="bg-midnight-black py-16 text-center">
        <p className="text-stranger-orange text-xs font-bold tracking-[0.25em] uppercase mb-3">Questions</p>
        <h1 className="text-clean-white font-extrabold uppercase tracking-tight text-3xl sm:text-5xl">Frequently Asked Questions</h1>
      </section>
      <section className="bg-clean-white py-16">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Accordion type="single" collapsible data-testid="faq-accordion">
            {faqs.map((f, i) => (
              <AccordionItem key={f.id} value={`item-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger className="text-left font-bold text-base">{f.question}</AccordionTrigger>
                <AccordionContent className="text-midnight-black/75 font-medium leading-relaxed">{f.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>
    </div>
  );
}
